import axios from "axios";
import { handleApiError } from "@utils/errorHandler";

/**
 * Download a file from a URL that requires authentication (JWT Bearer token).
 * 
 * @param {string} downloadLink - The URL to download the file from.
 * @param {string} [fallbackFileName="download"] - Used if the filename
 * cannot be resolved from the response's content-disposition header.
 */
export const downloadFileFromUrl = (downloadLink, fallbackFileName = "download") => {
  if (!downloadLink) return;

  axios
    .get(downloadLink, { responseType: "blob" })
    .then((response) => {
      const blobUrl = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = blobUrl;
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
        : fallbackFileName;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch((error) => handleApiError(error));
};

export default downloadFileFromUrl;
